<template>
    <el-dialog
        class="report"
        :visible.sync="reportVisible"
        :close-on-click-modal="false"
        @close="closeDialog"
        width="600px"
        title="报告内容"
    >
        <div v-html="reportConrent"></div>

        <div slot="footer" class="dialog-footer">
            <el-button @click="reportVisible = false">关 闭</el-button>
        </div>
    </el-dialog>
</template>
<script>

export default {
    data() {
        return {
            reportConrent:""
        };
    },
    methods: {
        closeDialog() {
            this.$emit("update:reportVisible", false);
        },
    },
    props: {
        reportVisible: Boolean,
        reportConrent: String,
    },
    watch: {
        reportVisible: {
            handler(val) {

            },
        },
    },
    computed: {

    },
    components: {

    },
};
</script>
<style lang="scss">
.report {
    .el-dialog__body {
        display: flex;
        justify-content: center;
        padding: 40px!important;

        >div {
            width: max-content;
            text-align: left;
            line-height: 190%;

            h3 {
                line-height: 200%;
            }

            p {
                >strong {
                    margin-top: 10px;
                    display: block;
                }
            }
        }
    }
}
</style>
